import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { jsPDF } from "jspdf";
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

import { Loan } from "../loan";
import { LoanService } from "../../shared/loan.service";

@Injectable({
  providedIn: 'root'
})

export class PrintloanreceiptService {

  private selectedLoan: Loan;
  constructor(private httpClient: HttpClient,
    private loanService: LoanService, public datePipe: DatePipe,) { }

    getBaseUrl() {
      return environment.baseUrl;
    }

    GenerateReport(rptSearchData: any) {

      this.FetchReceiptList(rptSearchData)
        .toPromise()
        .then(data => {
          // console.log(data);
        if(data.length>0){
          this.ReportGenerateList(data,this.datePipe);
          }
          else{
            console.log('data not found!');
          }
        })
        .catch(err => { console.log(err) });
    }
  
    FetchReceiptList(rptSearchData: any) {
      this.selectedLoan = new Loan();
      this.selectedLoan.CustomerId = rptSearchData.customerId;
      this.selectedLoan.ReportName = rptSearchData.ReportName;
      this.selectedLoan.ToDate = rptSearchData.LoanToDate;
      this.selectedLoan.BranchId = rptSearchData.BranchId;
      this.selectedLoan.CentreId = rptSearchData.CentreId;
      this.selectedLoan.IsLoanPreclosure = rptSearchData.StatusId;
  
      this.selectedLoan.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
      this.selectedLoan.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
      this.selectedLoan.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
      this.selectedLoan.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
  
      let body = this.selectedLoan;
      const headers = new HttpHeaders();
      headers.set('Content-Type', 'application/json; charset=utf-8');
      return this.httpClient.post<any>(this.getBaseUrl() + 'api/Loan/Report', body, { headers: headers });
    }

  //--------------------------------------------------
  // Printing the documents as a lists.  
  ReportGenerateList(LoanList,datePipe: DatePipe) {

    var generateData = function (LoanList) {

      var result = [];
      var itemData = [{}];
      // let todayDate = new Date(); 
      // console.log(datePipe.transform(todayDate, 'yyyy-MM-dd'));

      for (var i = 0; i < LoanList.length; i += 1) {
        itemData[i] = {
          Id: LoanList[i].Id.toString(),
          'Loan No.':  LoanList[i].LoanNumber.toString(),
          'Loan Amount': LoanList[i].LoanAmount.toString(),
          'Customer': LoanList[i].CustomerName.toString(), // + ' ['+ LoanList[i].CustomerCode.toString() + ']',
          'Receipt No.': LoanList[i].ReceiptNo.toString(),
          'Date': datePipe.transform(LoanList[i].LoanPayDate, 'dd-MM-yyyy').toString(),
          'Principle Amount':LoanList[i].PrincipleAmount.toString(),
          'Interest Amount' : LoanList[i].InterestAmount.toString(), 
          'Net. Amount': LoanList[i].TotalDemand.toString(),
          'Savings Outst.': LoanList[i].SavingsBalance.toString(),
        };
      }

      for (var i = 0; i < LoanList.length; i += 1) {
        itemData[i]['Id'] = (i + 1).toString();
        result.push(Object.assign({}, itemData[i]));
      }

      return result;
    };


    function createHeaders(HeaderName) {

      var HeaderResult = [];
      for (var i = 0; i < HeaderName.length; i += 1) {
        HeaderResult.push({
          id: HeaderName[i],
          name: HeaderName[i],
          prompt: HeaderName[i],
          width: 78,
          align: "left",
          padding: 0,
        });
      }
      return HeaderResult;
    }

    var headers = createHeaders([
      "Id",
      "Loan No.",
      "Loan Amount",
      "Customer",
      "Receipt No.",
      "Date",
      "Principle Amount",
      "Interest Amount",
      "Net. Amount",
      "Savings Outst.",
    ]);

    let pdf = new jsPDF('p', 'pt', 'A4');
    pdf.setProperties({
      title: 'Loan Receipts',
      subject: 'Info about PDF',
      author: 'PDFAuthor',
      keywords: 'generated, javascript, web 2.0, ajax',
      creator: 'SRI'
    });
    
    let todayDate = new Date(); 

    // Top HEADER
    pdf.setTextColor(0, 0, 0);
    pdf.setFontSize(14);
    pdf.setFont('arial', 'normal');
    pdf.text("Society For Rural Improvements", 220, 40);  // 40 is the height
    // pdf.text("Loan Receipt", 425, 100);

    pdf.setLineWidth(1.2);
    pdf.line(5, 105, 590, 105)
    // Top HEADER END 

    // Second Top HEADER
    pdf.setFontSize(10);
    pdf.setFont('arial', 'normal');
    pdf.text("Branch	: " + LoanList[0].CustomerBranchName.toString(), 25, 140);
    pdf.text("Centre	: " + LoanList[0].CentreName.toString(), 25, 160);

    // pdf.text("Loan Type :" + LoanList[0].LoanTypeName.toString(), 400, 120);
    // pdf.text("Loan Category :" + LoanList[0].CategoryName.toString(), 400, 140);
    pdf.text("Loan Scheme	 :" + LoanList[0].SchemeName.toString(), 400, 160);

    pdf.line(5, 185, 590, 185)   // x-axis, -x-axix,  y-axis  , -y-axix

    pdf.table(5, 190, generateData(LoanList), headers, { autoSize: false });
    pdf.output('dataurlnewwindow');
  }
}
